import { RouteObject } from 'react-router-dom';
import { defaultRoutes } from './configs/defaultRoutes';
import { userRoutes } from './configs/userRoutes';
import { resellerRoutes } from './configs/resellerRoutes';

export interface RouteConfig {
  getRoutes: (
    isAuthenticated: boolean,
    handleLogin: (token: string) => void,
    handleLogout: () => void
  ) => RouteObject[];
}

export const getRouteConfig = (): RouteConfig => {
  const routeConfigType = process.env.REACT_APP_ROUTE_CONFIG || 'default';

  switch (routeConfigType) {
    case 'user':
      return userRoutes;
    case 'reseller':
      return resellerRoutes;
    case 'default':
    default:
      return defaultRoutes;
  }
};

// Environment-based configuration helpers
export const getEnvironmentConfig = () => {
  return {
    baseUrl: process.env.REACT_APP_BASE_URL || '/',
    authRequired: process.env.REACT_APP_AUTH_REQUIRED === 'true',
    defaultAuthenticatedRoute: process.env.REACT_APP_DEFAULT_AUTHENTICATED_ROUTE || '/dashboard',
    defaultUnauthenticatedRoute: process.env.REACT_APP_DEFAULT_UNAUTHENTICATED_ROUTE || '/login',
    routeConfigType: process.env.REACT_APP_ROUTE_CONFIG || 'default'
  };
};
